<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

const encryptedText = this.CryptoJS.AES.encrypt("Hi There!",  'secret key 123').toString()
const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto)=>{
        return this.CryptoJS.AES.encrypt(texto,  'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto)=>{
        return this.CryptoJS.AES.decrypt(texto,'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf,num_cand)=>{

        let candidato = {CPF:cpf,NUMEROINSC:num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-','')*7919;
        codigo_meio=codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0,5))*parseInt(candidato.NUMEROINSC.replace('-',''))*13 + '_'
        + String.fromCharCode(65 + parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[1]))
        + String.fromCharCode(parseInt(codigo_meio[4]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[7]%2===0? 97 : 67)+ parseInt(codigo_meio[7]))
        + '-'
        + String.fromCharCode(parseInt(codigo_meio[0]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))
        + String.fromCharCode(parseInt(codigo_meio[5]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[8]))
        + '_'
        + String.fromCharCode(parseInt(codigo_meio[2]%2===0? 97 : 67)+ parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[6]))
        + String.fromCharCode(parseInt(codigo_meio[6]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))

        return codigo_arquivo+'.pdf';
      }


      let cands = [
  {
    "num_cand": "U2FsdGVkX1+4qvkWlZj0nkeqYvtT03wB/q22iAOLNhA=",
    "cpf": "U2FsdGVkX1+NBhfQrTWYBai+hUY4G+590rZpGf6xNZg="
  },
  {
    "num_cand": "U2FsdGVkX193LqOLbL5yUXBgOQLA2ki65j1KLV+jRJA=",
    "cpf": "U2FsdGVkX1+T9fzJVGhrz+A4msT0ZekkTc93wI+7t6A="
  },
  {
    "num_cand": "U2FsdGVkX19fKqz/1Rq2Tlcu9q5qgXwRCJ3Xhvd+xWw=",
    "cpf": "U2FsdGVkX1/+iFxMkaK3mdJlXG6SBmjAXXwtKTUKuI0="
  },
  {
    "num_cand": "U2FsdGVkX182rtnlqxkCCIIVdPLXDeSMF4NSE5JRW6A=",
    "cpf": "U2FsdGVkX1/4XDvobyfF30qdk5Pn0F1GpBqjdh+2D94="
  },
  {
    "num_cand": "U2FsdGVkX1/ihQ4+n/Y6DU2BaW/KJoDgCQ2gyUlQCl0=",
    "cpf": "U2FsdGVkX1/vPqWMYxMQkxVG+YUIxxLE58qa2gAoMYI="
  },
  {
    "num_cand": "U2FsdGVkX1+peDthQFcPMP7dENk+XW3T05ApByK78oA=",
    "cpf": "U2FsdGVkX19t5ipfeKDOAZGo3mynqoNMxfiSyHA7m9Q="
  },
  {
    "num_cand": "U2FsdGVkX1/tncd/YC/dwAYyjguURnt18Hwgnnqr4zg=",
    "cpf": "U2FsdGVkX19m0gHZFqFp5xgkBiUkn19GViDuoxP/1dA="
  },
  {
    "num_cand": "U2FsdGVkX19tSUvnpxJ18L4c1FLMVuJbQBOKUr4Ewec=",
    "cpf": "U2FsdGVkX1+GBTG4iteeiLbRh4Q2wChrtkbLuNsowjk="
  },
  {
    "num_cand": "U2FsdGVkX19UF3G2P/qkV38BuHjCm7R5WVf3KyBIsrQ=",
    "cpf": "U2FsdGVkX19ewhqvtHIYlc3EaHsmo/sm4orrPAWvlFA="
  },
  {
    "num_cand": "U2FsdGVkX197GreQxsrty/lk8Li3VccFVr9f30FP9jc=",
    "cpf": "U2FsdGVkX1/Nkvm2GYQ8oijz0Lh6bTTUnligplCAWhg="
  },
  {
    "num_cand": "U2FsdGVkX1/CfcVLEnJO5krr3bAtt4whT2e/EMLRUbk=",
    "cpf": "U2FsdGVkX1/vy54XV51rinRzBNbuYCy3tt6Y9KstkGw="
  },
  {
    "num_cand": "U2FsdGVkX185ShFJujw36lxvJAhgb119h788emPgdRg=",
    "cpf": "U2FsdGVkX18l2eaPEuxThRvIRk88CKTlEk9CfhKexto="
  },
  {
    "num_cand": "U2FsdGVkX192LbQJCRa2rKmccgtbmSvqqgEsr+vbc0o=",
    "cpf": "U2FsdGVkX1/SCEmjrfpDM19rj7OIlDFVkTnvF2BwUkI="
  },
  {
    "num_cand": "U2FsdGVkX1/P5x/fFJDAQEjZUpodZofB6ugiD7WXn90=",
    "cpf": "U2FsdGVkX19ui1f4qUHLhUXUVzrhrvZ+6pg8X6o50jk="
  },
  {
    "num_cand": "U2FsdGVkX18A7YlK0vGncnFz3AWAGlOEIEqzHFILq8s=",
    "cpf": "U2FsdGVkX1/8u3rIB3QBu3UsVbFhvpGQyx5GardXqWQ="
  },
  {
    "num_cand": "U2FsdGVkX18+HpVn429k+BbeeVe/PwvsWdlpKQPTn/0=",
    "cpf": "U2FsdGVkX1/i+/k50GwBnfubSY9q+crS8V06vpbHXXE="
  },
  {
    "num_cand": "U2FsdGVkX18LcwNY/ZyomnhG9WggiFlF01wLTkD/Qgc=",
    "cpf": "U2FsdGVkX18OBrcHqNN9vAIdnMwiYPkOh0RhzhinzE0="
  },
  {
    "num_cand": "U2FsdGVkX1/n2lKu8fO6Qf7KPGaiTqJME/Vb6deF7iQ=",
    "cpf": "U2FsdGVkX1/mgEriPwBlLhMKUvXyVVw5kjA9YqqJils="
  },
  {
    "num_cand": "U2FsdGVkX1/wK7BWCbIXo3IMUoI33r8ANpAIVH3a1cc=",
    "cpf": "U2FsdGVkX1+RGMxfrF/spJZ7bKFBCIIDyhyyVAZEwRU="
  },
  {
    "num_cand": "U2FsdGVkX18e3dZa00DRmbA+x99ggPW0lNfUM5Jpk9Q=",
    "cpf": "U2FsdGVkX1+nkOF7AasHH1yK2g/2C37Erehctv45bS0="
  }
]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
            let num_cand_decripted = decrypt(login.num_cand);
            let cpf_decripted = decrypt(login.cpf);

            // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
             let nome_arquivo = (gera_file_name(cpf_decripted,num_cand_decripted))


            // alert(`Logou`);
              let url = (`https://fs.ibfc.org.br/arquivos/2113/2113_rec_inscr/${nome_arquivo}`)
            return window.location.replace(url);
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
